import { Component, ViewChild } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from '../../components/ionic2-super-tabs/src';
import { SuperTabsComponent } from '../../components/ionic2-super-tabs/src/components/super-tabs';

import { XpReportCustomerClientPage } from "../xp-report-customer-client/xp-report-customer-client";
import { XpReportSelectUnitPage } from "../xp-report-select-unit/xp-report-select-unit";
import { XpReportFilesPage } from "../xp-report-files/xp-report-files";
import { XpReportWorkorderPage } from "../xp-report-workorder/xp-report-workorder";
import { XpReportMeasurementPage } from "../xp-report-measurement/xp-report-measurement";
import { XpReportRepairsPage } from "../xp-report-repairs/xp-report-repairs";
import { XpReportChecklistPage } from "../xp-report-checklist/xp-report-checklist";
import { XpReportSubmitPage } from "../xp-report-submit/xp-report-submit";
import { XpReportService } from "../../services/xp-report.service";
import { DataService } from "../../services/data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'page-xp-report',
  templateUrl: 'xp-report.html',
})
export class XpReportPage {

  @ViewChild('mainTabs') superTabs: SuperTabsComponent;

  data: any;

  reportWorkorderPage = XpReportWorkorderPage;
  reportCustomerClientPage = XpReportCustomerClientPage;
  reportSelectUnitPage = XpReportSelectUnitPage;
  reportFilesPage = XpReportFilesPage;
  reportMeasurementPage = XpReportMeasurementPage;
  reportRepairsPage = XpReportRepairsPage;
  reportChecklistPage = XpReportChecklistPage;
  reportSubmitPage = XpReportSubmitPage;

  showAllTabs = true;
  hasRookgasmetingSubscription = false;

  tabs = [
    { page: XpReportMeasurementPage, id: 'ReportMeasurementPage', caption: 'Series'},
    { page: XpReportRepairsPage, id: 'ReportRepairsPage', caption: 'Ejercicios'},
    { page: XpReportChecklistPage, id: 'ReportChecklistPage', caption: 'Notas'},
  ];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController,
      public reportService: XpReportService,
      public alertCtrl: AlertController,
      public translate: TranslateService,
      public dataService: DataService
  ) {
    this.data = this.reportService.getData();
    this.data._status = 'processing';
    if(!this.data._valid) this.data._valid = {};

    // Beperkte tabs als workorder_type Recyclage (4), Garantiekaart invullen (6)
    if(this.data.workorder_type == '4' || this.data.workorder_type == '6'){
      this.showAllTabs = false;
      this.data._valid.reportMeasurementPage = 1;
      this.data._valid.reportRepairsPage = 1;
      this.data._valid.reportChecklistPage = 1;
    }
    this.data._show_all_tabs = this.showAllTabs;

    if(this.data._has_invoice_customer == null){
      if(this.data.workorder_id && this.data.customers.invoice){
        this.data._has_invoice_customer = 1;
      } else {
        this.data._has_invoice_customer = 0;
      }
    }
    if(this.data._has_external_customer == null) {
      if (this.data.workorder_id && this.data.customers.external) {
        this.data._has_external_customer = 1;
      } else {
        this.data._has_external_customer = 0;
      }
    }

    // Migratie _selected_unit naar _selected_units (Verwijder in latere release)
    if(this.data._selected_units == null){
      this.data._selected_units = [];
      if(this.data._selected_unit){
        this.data._selected_units.push(this.data._selected_unit);
      }
    }

    // Notes alert weergeven
    if(this.data.notes){
      this.alertCtrl.create({
        title: this.translate.instant('Opmerking'),
        message: this.data.notes,
        buttons: ['OK']
      }).present();
    }

    // Update brands
    this.dataService.updateUnitBrands().then(() => {}).catch(() => {});

    // Update devices
    this.dataService.updateDevices().then(() => {}).catch(() => {});

    // Update company_users
    this.dataService.updateCompanyUsers().then(() => {}).catch(() => {});
  }

  getTitle(){
    let title = 'Meten en rapporteren';
    switch(this.data.workorder_type){
      case '1':
        title = this.translate.instant('1e inbedrijfstelling');
        break;
      case '2':
        title = this.translate.instant('Onderhoud');
        break;
      case '3':
        title = this.translate.instant('Storing');
        break;
      case '4':
        title = this.translate.instant('Toestel verwijderen');
        break;
      case '5':
        title = this.translate.instant('Aanmelden nieuwe installatie');
        break;
      case '6':
        title = this.translate.instant('Garantiekaart invullen');
        break;
      case '7':
        title = this.translate.instant('Buitenbedrijfstelling');
        break;
    }
    return title;
  }

  ngAfterViewInit() {
    // init tab colors
    if(this.data._valid.reportWorkorderPage === 1) this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_ok', 'mainTabs');
    if(this.data._valid.reportCustomerClientPage === 1) this.superTabsCtrl.setColor('reportCustomerClientPage', 'tab_ok', 'mainTabs');
    if(this.data._valid.reportSelectUnitPage === 1) this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_ok', 'mainTabs');
    if(this.showAllTabs){
      if(this.data._valid.reportFilesPage === 1) this.superTabsCtrl.setColor('reportFilesPage', 'tab_ok', 'mainTabs');
      if(this.data._valid.reportMeasurementPage === 1) this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_ok', 'mainTabs');
      if(this.data._valid.reportRepairsPage === 1) this.superTabsCtrl.setColor('reportRepairsPage', 'tab_ok', 'mainTabs');
      if(this.data._valid.reportChecklistPage === 1) this.superTabsCtrl.setColor('reportChecklistPage', 'tab_ok', 'mainTabs');
    }

    if(this.data._valid.reportWorkorderPage === -1) this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_error', 'mainTabs');
    if(this.data._valid.reportCustomerExternalPage === -1) this.superTabsCtrl.setColor('reportCustomerExternalPage', 'tab_error', 'mainTabs');
    if(this.data._valid.reportSelectUnitPage === -1) this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_error', 'mainTabs');
    if(this.showAllTabs) {
      if (this.data._valid.reportFilesPage === -1) this.superTabsCtrl.setColor('reportFilesPage', 'tab_error', 'mainTabs');
      if (this.data._valid.reportMeasurementPage === -1) this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_error', 'mainTabs');
      if (this.data._valid.reportRepairsPage === -1) this.superTabsCtrl.setColor('reportRepairsPage', 'tab_error', 'mainTabs');
      if (this.data._valid.reportChecklistPage === -1) this.superTabsCtrl.setColor('reportChecklistPage', 'tab_error', 'mainTabs');
    }
  }

  onTabSelect(tab: { index: number; id: string; }) {
    console.log(`Selected tab: `, tab);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportPage');
  }

  ionViewWillLeave(){
    console.log('ionViewWillLeave ReportPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report/xp-report.ts